import { Component, Input } from '@angular/core';
import { IconComponent, IconSize } from '../icon/icon.component';
import { CopyToClipboardDirective } from './copy-to-clipboard.directive';

@Component({
  selector: 'web-design-system-copy-to-clipboard',
  templateUrl: './copy-to-clipboard.component.html',
  styleUrls: ['./copy-to-clipboard.component.scss'],
  imports: [CopyToClipboardDirective, IconComponent],
})
export class CopyToClipboardComponent {
  @Input() public showLabel?: boolean = true;
  @Input() public label?: string;
  @Input() public hint?: string;
  @Input() public iconCssClass?: string;
  @Input() public labelCssClass?: string;
  @Input() public href?: string;
  @Input() public iconSize: IconSize = 'small';

  public isActive = false;

  public displayCopiedIbanHint = (): void => {
    this.isActive = true;

    setTimeout(() => {
      this.isActive = false;
    }, 2000);
  };
}
